// extracted by mini-css-extract-plugin
module.exports = {"Title":"article_information-module--Title--3TU41"};